// YesNoRadioGroup.js
import styles from "./YesNo.module.css";
import React, { useState } from 'react';
import RadioButton from './RadioButton';

const YesNoRadioGroup = () => {
  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div>
      <RadioButton
        name="yesNoGroup"
        value="Yes"
        checked={selectedValue}
        onChange={handleChange}
      />
      <RadioButton
        name="yesNoGroup"
        value="No"
        checked={selectedValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default YesNoRadioGroup;



